import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import axios from "../../api/axios";
import { filterTrackedEntitiesByCreatedAt, formatDataGeneral, getAttributeValue } from "../../utils/utils";
import APRComment from "./APRComment.js/AprComments";
import APRmemo from "./APRComment.js/APRmemo";

const Annex3c = forwardRef(({ year, district, period, hideTableDis, assessmentStatus }, ref) => {

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    getProjects();
  }, [year, district, period]);

  useImperativeHandle(ref, () => ({
    getData: () => ({
      indicator: "Table_8",
      tableData
    }),
  }));

  function getProjects() {
    axios
      .get(`/tracker/trackedEntities?orgUnit=${district}&program=g3wMUKEMmH3&startDate=${year}-01-01&endDate=${year}-12-31&pageSize=5000`)
      .then(result => {

        if (result.data.instances.length > 0) {
          const startDate = `${year}-01-01`;
          const endDate = `${year}-12-31`;

          axios
            .get(`/tracker/events?program=g3wMUKEMmH3&orgUnit=${district}&startDate=${year}-01-01&endDate=${year}-12-31&pageSize=5000`)
            .then(resp => {
              const data = filterTrackedEntitiesByCreatedAt(result.data.instances, year, period);
              const projects = formatDataGeneral(data, "Project & Programme Type", "Programme") || [];

              const reports = filterTrackedEntitiesByCreatedAt(resp.data.instances, startDate, endDate);

              const temps = [];

              projects.forEach((project, idx) => {

                const currentReport = reports.find(rep => rep.trackedEntity === project.trackedEntity);
                let expenditure = 0.00;
                let percentage = 0;

                if (currentReport) {

                  currentReport.dataValues.forEach(rep => {
                    if (rep.dataElement === "jr8gk707kAw") {
                      expenditure = rep.value;
                    }

                    if (rep.dataElement === "f1T48vHfJc1") {
                      percentage = rep.value;
                    }
                  });

                }

                const sumTotal = getAttributeValue("Contract Sum", project);

                const dataSetTemp = {
                  no: idx + 1,
                  description: getAttributeValue("Description", project),
                  dimension: getAttributeValue("Development Dimension", project),
                  contractSum: sumTotal,
                  fundingSource: getAttributeValue("Primary Funding Source", project),
                  dateStarted: getAttributeValue("Start Date", project),
                  expectedCompletion: getAttributeValue("Expected Completion Date", project),
                  expenditure: expenditure,
                  outstanding: parseFloat(sumTotal) - parseFloat(expenditure),
                  implementationStatus: percentage,
                  beneficiariesMale: getAttributeValue("Total Male Beneficiary", project),
                  beneficiariesFemale: getAttributeValue("Total Female Beneficiary", project),
                  remarks: getAttributeValue("Remarks", project)
                };

                temps.push(dataSetTemp);
              });

              setTableData(temps);
            })
            .catch(err => console.log(err))
        }
      })
      .catch(err => console.log(err))
  }
  
  const tableStyle = {
    border: '1px solid #000',
    borderCollapse: 'collapse',
    width: '100%',
    marginTop: "20px"
  };

  const thStyle = {
    border: '1px solid #000',
    fontWeight: 'bold',
    backgroundColor: '#d4edda',
    textAlign: 'center',
    verticalAlign: 'middle',
    padding: '8px'
  };

  const tdStyle = {
    border: '1px solid #000',
    verticalAlign: 'top',
    padding: '8px'
  };

  return (
    <div className="col-12">
      <h3>Annex 3c. Register of Key Regional Programmes</h3>
      <div className="card">
        <div className="card-header"></div>
        <div className="card-body">
          <APRmemo
            year={year}
            districtId={district}
            tableCommentedId={`Annex_3c-${year}`}
            hideTableDis={hideTableDis}
            assessmentStatus={assessmentStatus}
            period={period}
          />
          
          {/* Single Combined Table */}
          <div className="table-responsive">
            <table className="table table-bordered" style={tableStyle}>
              <thead>
                <tr style={{ backgroundColor: '#d4edda', fontWeight: 'bold' }}>
                  <th style={{ ...thStyle, width: '15%' }}>Programme Description</th>
                  <th style={{ ...thStyle, width: '10%' }}>Development Dimension</th>
                  <th style={{ ...thStyle, width: '8%' }}>Amount Involved (GHS)</th>
                  <th style={{ ...thStyle, width: '8%' }}>Source of Funding</th>
                  <th style={{ ...thStyle, width: '7%' }}>Date Started</th>
                  <th style={{ ...thStyle, width: '7%' }}>Expected Completion</th>
                  <th style={{ ...thStyle, width: '7%' }}>Expenditure to Date</th>
                  <th style={{ ...thStyle, width: '7%' }}>Outstanding Balance</th>
                  <th style={{ ...thStyle, width: '4%' }}>Implementation Status (%)</th>
                  <th style={{ ...thStyle, width: '10%' }}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={index}>
                    <td style={tdStyle}>{row.description}</td>
                    <td style={tdStyle}>{row.dimension}</td>
                    <td style={tdStyle}>{row.contractSum}</td>
                    <td style={tdStyle}>{row.fundingSource}</td>
                    <td style={tdStyle}>{row.dateStarted}</td>
                    <td style={tdStyle}>{row.expectedCompletion}</td>
                    <td style={tdStyle}>{row.expenditure}</td>
                    <td style={tdStyle}>{row.outstanding}</td>
                    <td style={tdStyle}>{row.implementationStatus}</td>
                    <td style={tdStyle}>{row.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          <p className="mt-2">
            <small>Source: MPCU</small>
          </p>

          <APRComment
            data={tableData}
            year={year}
            districtId={district}
            tableCommentedId={`table8-${year}`}
          >
            {({ renderCommentInput, renderCommentList }) => (
              <>
                {renderCommentInput()}
                {renderCommentList()}
              </>
            )}
          </APRComment>

        </div>
      </div>
    </div>
  );
});

export default Annex3c;